import { Table } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { CharterInvoiceGroupsQuery } from "__generated__/view/declarations/graphql/declaration.queries.generated";
import OverflowTooltip from "components/cck/OverflowTooltip";
import { Box, Tooltip } from "@mui/material";
import { ChildProps } from "types/commons";
import { getInvoiceGroupStatusConfig, InvoiceGroupStatus } from "view/declarations/invoiceGroupStatus";

type InvoiceGroup = ChildProps<CharterInvoiceGroupsQuery, "charter">["invoiceGroups"][number];
type InvoiceGroupAgreementRow = InvoiceGroup["agreements"][number];

const AgreementsTable = ({ agreements }: { agreements: InvoiceGroupAgreementRow[] }) => {
	return (
		<Table
			id="agreementsTable"
			disableFooter
			content={agreements.map(a => ({ ...a, id: a.agreement.id }))}
			columns={[
				{
					id: "ready",
					title: "",
					defaultPinned: true,
					disableMoveable: true,
					disablePinnable: true,
					disableVisibility: true,
					disableFlexGrow: true,
					disableResizing: true,
					width: 32,
					render: (row: InvoiceGroupAgreementRow) => {
						const tagConfig = getInvoiceGroupStatusConfig(row);
						return (
							<Tooltip title={tagConfig.label} placement="top" arrow>
								<Box
									component="span"
									sx={{
										display: "inline-block",
										width: 14,
										height: 14,
										borderRadius: "50%",
										backgroundColor: tagConfig.color,
										verticalAlign: "middle",
									}}
								/>
							</Tooltip>
						);
					},
				},
				{
					id: "type",
					title: intl.formatMessage({ id: "AGREEMENT" }),
					width: 200,
					disableFlexGrow: true,
					render: (row: InvoiceGroupAgreementRow) => intl.formatMessage({ id: `AGREEMENT_TYPE_${row.agreement.type}` }),
				},
				{
					id: "summary",
					title: intl.formatMessage({ id: "CALCULATION" }),
					render: (row: InvoiceGroupAgreementRow) => <OverflowTooltip>{row.agreement.calculationMethod?.summary}</OverflowTooltip>,
				},
			]}
		/>
	);
};

export default AgreementsTable;
